/// <amd-module name="Widgets/AnalyticsSprintBurndown/AnalyticsSprintBurndownWidgetComponents/TfsQueries/TeamWorkingDaysCacheableQuery" />
import { getWorkClient, IWorkRestClient } from "Dashboards/Clients/Work";
import { ICacheableQuery } from "Reporting/Common/ICacheableQuery";
import { IProjectData } from "Tfs/Platform/Page";
import * as TfsWidgetContext from "Tfs/Widget/Context";
import { IVssPageContext } from "VSS/Platform/Context";
import { DayOfWeek } from "WidgetCommon/DateUtils/DateUtils";

export class TeamWorkingDaysCacheableQuery implements ICacheableQuery<DayOfWeek[]> {
    private projectData: IProjectData;
    private teamId: string;

    constructor(private pageContext: IVssPageContext, teamId: string) {
        this.projectData = TfsWidgetContext.getProject(this.pageContext);
        this.teamId = teamId;
    }

    public async runQuery(pageContext: IVssPageContext): Promise<DayOfWeek[]> {
        const workClient: IWorkRestClient = getWorkClient(pageContext);
        const teamContext = {
            project: this.projectData.id,
            projectId: this.projectData.id,
            team: this.teamId,
            teamId: this.teamId
        };
        const teamSettings = await workClient.getTeamSettings(teamContext);
        return teamSettings.workingDays;
    }

    public getKey(): string {
        return (
            "TeamWorkingDaysCacheableQuery" +
            JSON.stringify({
                projectId: this.projectData.id,
                teamId: this.teamId
            })
        );
    }
}
